<div class="container">
    <div class="row">
        <div class="col-12 py-5">
            <div class="d-flex flex-column align-items-center my-5">
                <h1 class="text-primary pb-2 fs-1 fw-normal">Page non trouvée</h1>
                <h2 class="fs-2 fw-normal">La page que vous recherchez semble introuvable.</h2>
            </div>
        </div>
    </div>
</div>
